import { ISignificanceVariantPerfResult } from '../../interfaces';
import { significanceColors } from '../utils';

export const variantScatterColors: Record<
  ISignificanceVariantPerfResult,
  {
    dotColor: string;
    lineColor: string;
  }
> = {
  negative: {
    dotColor: significanceColors.danger,
    lineColor: '#f4ccccff',
  },
  positive: {
    dotColor: significanceColors.success,
    lineColor: '#71d7a3',
  },
};
